import axios from "axios";
import QS from 'qs';
import store from '../store';
import {domain} from '../config.js'

import {
  Loading,
  Message
} from 'element-ui';

axios.defaults.timeout = 5000;
axios.defaults.baseURL = domain; //填写域名
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// http request 拦截器
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // };
    // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断

    const user = store.state.user;
    // console.log('user')
    // console.log(user)
    user && (config.headers.Authorization = user.token);
    // 'Bearer' +
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

// 响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    if (response.data.code == 0) {
      //正确的
      return response;
    } else {
      //错误的
    }
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.code) {
        case 400:
          console.log("错误请求");
          break;
        case 401:
          console.log("未授权，请重新登录");
          break;
        default:
          console.log(`连接错误${err.response.code}`);
      }
    } else {
      console.log("连接到服务器失败");
    }
    return Promise.resolve(err.response);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {

        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  const loading = Loading.service({
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });

  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        loading.close();
        let res = response.data;
        if (res.code != 0) {
          Message.error(res.msg);
          reject(res);
        } else {
          resolve(res);
        }
      },
      err => {
        loading.close();
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js